import React, { useState, createContext, useEffect, useRef } from 'react';

import './functionalpagelogin.css';
import StatsCard from './popupsright/StatsCard';

import SidebarMenu from './SidebarMenu';
import RightMenu from './RightMenu';

import ShowLessonsModel from './ShowLessonsModel.jsx';
import ShowLessonsFinanciara from './ShowLessonsFinanciara';

// SidebarMenuItems imports
import Certificate from './SidebarMenuItems/Certificate';
import Clasament from './SidebarMenuItems/Clasament';
import CoursesInPlace from './SidebarMenuItems/CoursesInPlace';
import Medalii from './SidebarMenuItems/Medalii';
import Misiuni from './SidebarMenuItems/Misiuni';
import Profil from './SidebarMenuItems/Profil';
import Settings from '../../settings/Settings';

// ✅ Context exportat pentru folosire în alte componente
export const PageNavContext = createContext();



const FunctionalPageLoginStart = () => {
  const topRef = useRef(null);
  useEffect(() => {
    // Scroll la începutul paginii pe orice device, inclusiv mobil
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
    // Fallback pentru window
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  const [selectedMenu, setSelectedMenu] = useState('Invata');
  const [activeTab, setActiveTab] = useState('profil');
  const [selectedCourseId, setSelectedCourseId] = useState(() => {
    const saved = localStorage.getItem('selectedCourseId');
    const parsed = saved ? Number(saved) : 1;
    return [1, 2].includes(parsed) ? parsed : 1;
  });

  useEffect(() => {
    const handleCourseSelected = (e) => {
      const courseId = Number(e.detail);
      if (![1, 2].includes(courseId)) return;
      setSelectedCourseId(courseId);
      localStorage.setItem('selectedCourseId', String(courseId));
      setSelectedMenu('Invata');
    };

    window.addEventListener('courseSelected', handleCourseSelected);
    return () => window.removeEventListener('courseSelected', handleCourseSelected);
  }, []);

  // Navigare meniu simplă, ca la Clasament
  const handlePageNav = (menu) => {
    setSelectedMenu(menu);
  };

  const menuComponents = {
    'Invata': selectedCourseId === 2
      ? <ShowLessonsFinanciara />
        : <ShowLessonsModel />,
    'Profil': <Profil onMenuSelect={setSelectedMenu} />,
    'Certificate': <Certificate />,
    'Clasament': <Clasament />,
    'Medalii': <Medalii />,
    'Misiuni': <Misiuni />,
    'CoursesInPlace': <CoursesInPlace />,
    'Setari': (
      <Settings
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onBackToProfile={() => setSelectedMenu('Profil')}
      />
    ),
  };

  return (
    <PageNavContext.Provider value={handlePageNav}>
      <div className='main-emelents-course-orientation'>
        <div ref={topRef} />
        <div className='menu-left-principal'>
          <SidebarMenu onMenuSelect={setSelectedMenu} selectedMenu={selectedMenu} />
        </div>
        <div className='secons-portion-principal-layout'>
          <div className='orientation-menu-mobile'>

            {/* StatsCard eliminat la cerere */}

            {menuComponents[selectedMenu] || (
              selectedCourseId === 2
                ? <ShowLessonsFinanciara />
                  : <ShowLessonsModel />
            )}
          </div>
      
        </div>
        {/* CoursesInPlace va fi afișat central, ca orice alt meniu */}
      </div>
    </PageNavContext.Provider>
  );
};

export default FunctionalPageLoginStart;
